module.exports = __webpack_public_path__ + "static/media/AU Research Roster - 2b - deduped 2019 workshops.e035d658.csv";